<script setup lang="ts">
import { WidgetProfileLeadsTable } from '~/components/widget/profile-leads-table'
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'

const { t } = useI18n()
const { isLoggedIn } = useUser()
const { getPathWithLocale } = useLocalizedPath()

if (!isLoggedIn.value) {
  await navigateTo(getPathWithLocale('/login'))
}

definePageMeta({ robots: 'noindex' })

const breadcrumbs = computed(() => [
  { title: t('page.panel.breadcrumb'), url: '/panel' },
  { title: t('page.profile.leads.breadcrumb'), url: '/profile/leads' },
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <div class="space-y-5" role="main">
        <WidgetProfileLeadsTable />
      </div>
    </Container>
  </Main>
</template>
